import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      can: 'is-logged-in',
      fail: '/login',
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    meta: {
      can: 'is-logged-in',
      fail: '/',
    }
  },
  {
    path: '/trips',
    name: 'Trips',
    component: () => import(/* webpackChunkName: "trips" */ '../views/Trips.vue'),
    meta: {
      can: 'admin',
      fail: '/',
    }
  },
  {
    path: '/trips/:id',
    name: 'TripsDetail',
    component: () => import(/* webpackChunkName: "tripsDetail" */ '../views/TripsDetail.vue'),
    meta: {
      can: 'admin',
      fail: '/',
    },
    children: [
      {
        path: 'intro',
        name: 'TripsDetailIntro',
        component: () => import(/* webpackChunkName: "tripsDetailIntro" */ '../components/Trip/Form/Intro.vue'),
        meta: {
          can: 'admin',
          fail: '/',
        }
      },
      {
        path: 'itinerary',
        name: 'TripsDetailItinerary',
        component: () => import(/* webpackChunkName: "tripsDetailItinerary" */ '../components/Trip/Form/Itinerary.vue'),
        meta: {
          can: 'admin',
          fail: '/',
        }
      },
      {
        path: 'services',
        name: 'TripsDetailServices',
        component: () => import(/* webpackChunkName: "tripsDetailServices" */ '../components/Trip/Form/Services.vue'),
        meta: {
          can: 'admin',
          fail: '/',
        }
      },
    ],
  },
  {
    path: '/enquiries',
    name: 'Enquiries',
    component: () => import(/* webpackChunkName: "enquiries" */ '../views/Enquiries.vue'),
    meta: {
      can: 'operator',
      fail: '/',
    }
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: () => import(/* webpackChunkName: "bookings" */ '../views/Bookings.vue'),
    meta: {
      can: 'operator',
      fail: '/',
    }
  },
  {
    path: '/bookings/:id',
    name: 'BookingsDetail',
    component: () => import(/* webpackChunkName: "bookingsDetail" */ '../views/BookingsDetail.vue'),
    meta: {
      can: 'operator',
      fail: '/',
    }
  },
  {
    path: '/tourbook/release',
    name: 'TourbookRelease',
    component: () => import(/* webpackChunkName: "tourbookRelease" */ '../views/TourbookRelease.vue'),
    meta: {
      can: 'is-logged-in',
      fail: '/',
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
    meta: {
      can: 'is-logged-in',
      fail: '/login',
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue'),
    meta: {
      can: 'is-logged-in',
      fail: '/',
    }
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to) {
    if(to.hash) {
      return {selector: to.hash, offset: {x: 0, y: 60}};
    }
  }
});

export default router;
